jQuery(window).load(function () {
    var wrap = jQuery('#popup_overlay');
    var behavior = wrap.attr('data-behavior');
    if (behavior === 'window_load') {
        var visited = jQuery.cookie('visited');
        if (visited == 'yes') {
            // second page load, cookie active
        } else {
            popUp();
        }
        jQuery.cookie('visited', 'yes', {
            expires: Number(expire_days_cookie_popup)
        });
    }

});

function onMouseOut(event) {
    // If the mouse is near the top of the window, show the popup
    // Also, do NOT trigger when hovering or clicking on selects
    var wrap = jQuery('#popup_overlay');
    var behavior = wrap.attr('data-behavior');
    if (behavior === 'window_close' &&
        event.clientY < 2 &&
        event.relatedTarget == null &&
        event.target.nodeName.toLowerCase() !== 'select') {
        // Remove this event listener
        document.removeEventListener("mouseout", onMouseOut);

        // Show the popup
        var visited = jQuery.cookie('visited');
        if (visited == 'yes') {
            // second page load, cookie active
        } else {
            popUp();
        }
        jQuery.cookie('visited', 'yes', {
            expires: Number(expire_days_cookie_popup)
        });
    }
}

document.addEventListener("mouseout", onMouseOut);

function popUp() {
    var wrap = jQuery('#popup_overlay');
    jQuery('body').append(wrap);
    centerPopUp();
    if (wrap.length > 0) {
        jQuery('html').addClass('no_scroll');
        wrap.fadeIn();
        wrap.find('.close_popup').click(function () {
            wrap.fadeOut('fast');
            jQuery('html').removeClass('no_scroll');
        });

    }
}
function centerPopUp() {
    var wrap = jQuery('#popup');
    if (wrap.length > 0 && !is_mobile) {
        wrap.css({
            'position': 'absolute',
            'bottom': '60px',
            'left': '100px'
        })
    }
}